export default "__VITE_ASSET__Df246PvF__"